import type { IMessageReport } from '@/types/Data/ReportAPI'
import type { IGetMessageReport, ISendCustomPersonalMessage } from '@/types/Request'
import BaseService from '../BaseService'

export default class MessageServices extends BaseService {
  GetMessageList(data: IGetMessageReport) {
    return this.GET<IMessageReport[]>(this.PATHS.GET_MESSAGE_LIST, data)
  }

  GetMessageListExcel(data: IGetMessageReport) {
    return this.EXCEL(this.PATHS.GET_MESSAGE_LIST_EXCEL, false, data)
  }

  SendCustomPersonalMessage(payload: ISendCustomPersonalMessage) {
    return this.POST<void>(this.PATHS.SEND_CUSTOM_PERSONAL_MESSAGE, payload)
  }
}
